(function () {
  'use strict';
  function init() {
    var nav = document.querySelector('[data-kidis-breadcrumbs]');
    if (!nav || nav.dataset.ready) return;
    nav.dataset.ready = 'true';
    var data;
    try { data = JSON.parse(nav.querySelector('[data-kidis-breadcrumb-data]').textContent); } catch (error) { return; }
    var list = nav.querySelector('[data-kidis-breadcrumb-list]');
    var paths = [];
    function path(url) {
      try { var parsed = new URL(url, location.origin); return parsed.origin === location.origin ? parsed.pathname.replace(/^\/[a-z]{2}(?:-[a-z]{2})?(?=\/|$)/i, '').replace(/\/$/, '') || '/' : ''; } catch (error) { return ''; }
    }
    function item(link) {
      if (!link || !link.getAttribute('href') || link.getAttribute('href').charAt(0) === '#') return null;
      var label = link.querySelector('.km__t');
      return { title: (label || link).textContent.trim(), url: link.href };
    }
    function clean(trail) {
      var seen = new Set(['/']);
      return trail.filter(function (entry) { var key = path(entry.url); if (!key || seen.has(key) || !entry.title) return false; seen.add(key); return true; });
    }
    function add(trail) { var result = clean(trail); if (result.length) paths.push(result); }
    function walk(entries, parents) {
      (entries || []).forEach(function (entry) { var trail = parents.concat([{ title: entry.title, url: entry.url }]); add(trail); walk(entry.children, trail); });
    }
    (data.menu || []).forEach(function (menu) { walk(menu, []); });
    document.querySelectorAll('.km__item').forEach(function (group) {
      var top = item(group.querySelector('.km__top'));
      var parents = top ? [top] : [];
      add(parents);
      group.querySelectorAll('.km__link, .km__simple a, .km__sub a').forEach(function (link) {
        var child = item(link); if (child) add(parents.concat([child]));
      });
    });
    function find(url) {
      var key = path(url);
      return paths.filter(function (trail) { return path(trail[trail.length - 1].url) === key; }).sort(function (a, b) { return b.length - a.length; })[0];
    }
    function remembered() {
      try { return JSON.parse(sessionStorage.getItem('kidis-category-trail-v58') || 'null'); } catch (error) { return null; }
    }
    function remember(trail) {
      try { sessionStorage.setItem('kidis-category-trail-v58', JSON.stringify({ time: Date.now(), trail: clean(trail) })); } catch (error) {}
    }
    var title = data.title;
    var parents = [];
    if (data.type === 'product') {
      var collections = data.collections || [];
      var saved = remembered();
      var valid = function (trail) { return Array.isArray(trail) && trail.length && collections.some(function (c) { return path(c.url) === path(trail[trail.length - 1].url); }); };
      var source;
      try { source = path(document.referrer); } catch (error) {}
      var refCollection = collections.find(function (c) { return path(c.url) === source; });
      if (saved && Date.now() - saved.time < 1800000 && valid(saved.trail)) {
        var firstTrail = find(saved.trail[0].url);
        parents = clean((firstTrail || []).concat(saved.trail));
      }
      else if (refCollection) parents = find(refCollection.url) || [refCollection];
      else {
        var options = collections.map(function (c) { return { category: c, trail: find(c.url) }; }).filter(function (c) { return c.trail; });
        options.sort(function (a, b) { return b.trail.length - a.trail.length || a.category.count - b.category.count; });
        if (options.length) parents = options[0].trail;
        else if (collections.length) {
          var category = collections.filter(function (c) { return !/\/(all|sale|neu|bestseller)(\/|$)/i.test(path(c.url)); }).sort(function (a, b) { return a.count - b.count; })[0];
          if (category) parents = [category];
        }
        // Include the general category when the series itself is not in the menu.
        var extra = collections.filter(function (c) { return parents.length && path(c.url) !== path(parents[parents.length - 1].url) && !find(c.url) && title.toLowerCase().indexOf(c.title.toLowerCase()) === 0; })[0];
        if (extra) parents.push(extra);
      }
    } else {
      var current = find(data.url);
      if (current) parents = current.slice(0, -1);
      if (data.type === 'article' && data.blog) parents = find(data.blog.url) || [data.blog];
      if (data.type === 'collection') remember(parents.concat([{ title: title, url: data.url }]));
    }
    function render() {
      var trail = clean(parents);
      list.replaceChildren();
      if (data.type !== 'index') trail.unshift({ title: 'Startseite', url: data.home });
      trail.forEach(function (entry) {
        var li = document.createElement('li'); var link = document.createElement('a');
        link.href = entry.url; link.textContent = entry.title; li.appendChild(link); list.appendChild(li);
      });
      var li = document.createElement('li'); li.setAttribute('aria-current', 'page'); li.textContent = title; list.appendChild(li);
    }
    render();
    document.addEventListener('click', function (event) {
      var target = event.target.closest && event.target.closest('a[href]');
      if (!target) return;
      var key = path(target.href);
      if (key.indexOf('/collections/') !== 0) return;
      var trail = find(target.href) || [{ title: target.textContent.trim(), url: target.href }];
      remember(trail);
    }, true);
    document.addEventListener('kidis:product-changed', function () {
      var heading = document.querySelector('#MainContent h1');
      if (heading && heading.textContent.trim()) title = heading.textContent.trim();
      render();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
})();
